import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateFormatLocalePipe } from './translate-format-locale.pipe';
import { TranslateFormatPipe } from './translate-format.pipe';
import { TranslatePipe } from './translate.pipe';

const EXPORTED_ASSETS = [
    TranslatePipe,
    TranslateFormatPipe,
    TranslateFormatLocalePipe
];

@NgModule({
    declarations: [...EXPORTED_ASSETS],
    imports: [CommonModule],
    exports: [...EXPORTED_ASSETS]
})
export class TranslationsModule {}
